module.exports = __webpack_public_path__ + "static/media/LAMI-main-img.2cfe31dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/LAMI/LAMI-main-img.svg
// module id = 91
// module chunks = 0